import { Link } from '@mui/material';
import AuthLayout from '../../../components/shared/AuthLayout';
import SignInForm from '../../../components/auth/SignInForm';

const SignInPage = () => {
  const sideImageUrl = "https://images.unsplash.com/photo-1579546929662-711aa81148cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80";

  return (
    <AuthLayout
      sideImageUrl={sideImageUrl}
      FormComponent={SignInForm}
      pageTitle="Welcome Back"
      pageDescription="Sign in to continue your perfect roommate search journey"
      sideTitle="Find Your Perfect Roommate"
      sideSubtitle="Join thousands of happy roommates who found their ideal match. Sign in to continue your journey."
      additionalLink={
        <>
          Don't have an account? <Link href="/fmr/sign-up" color="primary">Sign up</Link>
        </>
      }
    />
  );
};

export default SignInPage;